export default "__VITE_ASSET__aa41cd13__"